import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  ChevronRight, 
  ChevronDown,
  BookOpen,
  Zap,
  Sparkles,
  Settings,
  Map,
  AlertCircle,
  FileText,
} from 'lucide-react';
import { docsStructure } from '../../docs';

const iconMap = {
  BookOpen,
  Zap,
  Sparkles,
  Settings,
  Map,
  AlertCircle,
  FileText,
};

const DocsSidebar = () => {
  const location = useLocation();
  const [expandedSections, setExpandedSections] = useState(['getting-started']);

  // Auto-expand current section
  useEffect(() => {
    const pathParts = location.pathname.split('/');
    if (pathParts[2]) {
      setExpandedSections(prev => {
        if (!prev.includes(pathParts[2])) {
          return [...prev, pathParts[2]];
        }
        return prev;
      });
    }
  }, [location.pathname]);

  const toggleSection = (sectionId) => {
    setExpandedSections(prev =>
      prev.includes(sectionId)
        ? prev.filter(id => id !== sectionId)
        : [...prev, sectionId]
    );
  };

  return (
    <nav className="space-y-1 py-4">
      {docsStructure.map(section => {
        const Icon = iconMap[section.icon] || FileText;
        const isExpanded = expandedSections.includes(section.id);
        
        return (
          <div key={section.id}>
            <button
              onClick={() => toggleSection(section.id)}
              className="flex items-center justify-between w-full px-3 py-2 text-sm font-medium rounded-lg hover:bg-purple-500/10 transition-colors group"
            >
              <span className="flex items-center gap-2">
                <Icon className="h-4 w-4 text-purple-400" />
                {section.title}
              </span>
              {isExpanded ? (
                <ChevronDown className="h-4 w-4 text-foreground/40 group-hover:text-foreground/60" />
              ) : (
                <ChevronRight className="h-4 w-4 text-foreground/40 group-hover:text-foreground/60" />
              )}
            </button>
            
            {isExpanded && (
              <div className="ml-6 mt-1 space-y-1 border-l border-border/40 pl-3">
                {section.pages.map(page => {
                  const pagePath = `/docs/${section.id}/${page.slug}`;
                  const isActive = location.pathname === pagePath;
                  
                  return (
                    <Link
                      key={page.slug}
                      to={pagePath}
                      className={`block px-3 py-2 text-sm rounded-lg transition-colors ${
                        isActive
                          ? 'bg-purple-500/20 text-purple-400 font-medium'
                          : 'text-foreground/70 hover:text-foreground hover:bg-purple-500/10'
                      }`}
                    >
                      {page.title}
                    </Link>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </nav>
  );
};

export default DocsSidebar;

